import * as React from 'react'
import type { SVGProps } from 'react'
const SvgVk = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.9382 6h-2.188C2.125 6 2 6.2968 2 6.6253c0 .5854.7414 3.4894 3.454 7.3301C7.2619 16.5783 9.8094 18 12.1274 18c1.391 0 1.5629-.3158 1.5629-.8596v-1.9825c0-.6316.1313-.7579.572-.7579.3251 0 .8815.1642 2.1793 1.4286C17.9251 17.3274 18.1695 18 19.0041 18h2.188c.6252 0 .9378-.3158.7571-.9392-.1969-.6208-.9052-1.5221-1.8454-2.5901-.5102-.6088-1.2754-1.265-1.5067-1.5928-.325-.4213-.2313-.6088 0-.9834 0 0 2.6657-3.7939 2.9445-5.0817.1388-.4686 0-.8128-.6627-.8128h-2.1874c-.5563 0-.8127.2968-.9514.6253 0 0-1.1128 2.7398-2.6888 4.5195-.5101.5154-.7421.6796-1.0203.6796-.1388 0-.34-.1642-.34-.6322V6.8128c0-.562-.162-.8128-.6252-.8128H9.6275c-.3476 0-.5564.2608-.5564.5084 0 .5324.7877.6556.869 2.1537v3.2558c0 .7137-.1276.8432-.4064.8432-.7414 0-2.5456-2.7525-3.6159-5.9015C5.7078 6.2463 5.4971 6 4.9382 6"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgVk
